module.exports = __webpack_public_path__ + "6613c4f53ed63133c06b4825b60e3daf.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/labels/clear.svg
// module id = /Gj5
// module chunks = 0